const actions = {
  SET_STATE: 'goals/SET_STATE',
  UPDATE_LONG_TERM_LIST: 'goals/UPDATE_LONG_TERM_LIST',
}

export default actions
